export const ATTACK_FX_CORE_DURATION_MS = 800;
export const ATTACK_FX_BULLET_DURATION_MS = 200;
export const REPAIR_FX_DURATION_MS = 800;

export const FLOATING_NUMBER_FADE_START = 0.85;

export const UNIT_DEATH_EXPLOSION_START = 0.3;
export const UNIT_DEATH_EXPLOSION_END = 0.85;

export const UNMOVED_HIGHLIGHT_HOLD_MS = 900;

export const UNMOVED_HIGHLIGHT_FADE_MS = 500;

export const ATTACK_RANGE_FLASH_PERIOD_MS = 1200;
export const ATTACK_RANGE_FLASH_EXPAND_MS = 280;
